export function templateStyle(obj = {}) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v).map(e => {
        const [k, v] = e;
        switch (k) {
            case 'background': return ['background-image', `url(${v})`];
        }
        return e;
    }));
}
export default function style(node, initialVars) {
    let oldVars = {};
    function applyStyles(vars = {}) {
        for (let [k, v] of Object.entries(vars)) {
            node.style.setProperty(k, v);
        }
        for (let k of Object.keys(oldVars)) {
            if (!(k in vars)) {
                node.style.setProperty(k, '');
            }
        }
        oldVars = vars;
    }
    applyStyles(initialVars);
    return {
        update(v) {
            applyStyles(v);
        },
    };
}
